var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFigurecrosstraining(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 17.9983 27.5039",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 27.5039,
    opacity: 0,
    width: 17.9983,
    x: 0,
    y: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.34682 5.09766C8.75307 5.09766 9.9015 3.94922 9.9015 2.55469C9.9015 1.14844 8.75307 0 7.34682 0C5.94057 0 4.79213 1.14844 4.79213 2.55469C4.79213 3.94922 5.94057 5.09766 7.34682 5.09766ZM0.573378 11.1094C-0.809435 13.0312 0.409315 15.6328 3.1515 15.2227L7.45228 14.5781L5.78822 19.5234C5.22572 21.1641 7.5226 21.8438 8.03822 20.2969L10.2531 13.582C10.5226 12.7734 10.0187 11.9766 9.06947 11.9766L4.82728 11.9766L7.05385 9.01172C7.2765 8.70703 7.41713 8.67188 7.7101 8.67188L16.4757 8.67188C17.1203 8.67188 17.6476 8.15625 17.6476 7.5C17.6476 6.85547 17.132 6.32812 16.4757 6.32812L5.33119 6.32812C4.51088 6.32812 3.714 6.75 3.19838 7.45312ZM1.60463 26.6016C1.60463 27.1406 1.97963 27.4922 2.53041 27.4922L11.3195 27.4922C11.8703 27.4922 12.2335 27.1406 12.2335 26.6016L12.2335 23.0742C12.2335 22.5469 11.8703 22.1953 11.3195 22.1953L2.53041 22.1953C1.97963 22.1953 1.60463 22.5469 1.60463 23.0742Z",
    fill: "currentColor",
    fillOpacity: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigurecrosstraining);
export default __webpack_public_path__ + "static/media/figure.cross.training.18f8bbe3d4b909d610866d94094c57e3.svg";
export { ForwardRef as ReactComponent };